import { head, tail } from '@bonitour/common-functions'

export const ExportColumnsParser = {
  columns: (columns) => {
    return Object.entries(columns).map((item) => ({ value: head(item), label: tail(item) }))
  }
}
